module.exports = __webpack_public_path__ + "static/assets/33bf0f35b15bb242da26a789453bef51.png";